var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5C11.6569 8.5 13 7.15685 13 5.5C13 3.84315 11.6569 2.5 10 2.5C8.34315 2.5 7 3.84315 7 5.5C7 7.15685 8.34315 8.5 10 8.5Z",
    stroke: "currentColor",
    strokeWidth: 1.52
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1429 16.2113C11.4934 16.3964 10.7669 16.5 10 16.5C7.23858 16.5 5 15.1568 5 13.5C5 11.8432 7.23858 10.5 10 10.5C12.7614 10.5 15 11.8432 15 13.5C15 13.759 14.9453 14.0103 14.8425 14.25",
    stroke: "currentColor",
    strokeWidth: 1.52,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFriend);
export default __webpack_public_path__ + "static/media/icon-friend.0cc51b3d0383352e4889fab89d07d9f9.svg";
export { ForwardRef as ReactComponent };